<template>
  <div id="app">
    <app-header></app-header>
    <router-view/>
    <app-footer></app-footer>
  </div>
</template>

<script>

  require('waypoints/lib/noframework.waypoints.js')

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'

  import {mapActions} from 'vuex';
  

  export default {
    name: 'App',
    components : {
      'app-header' : header,
      'app-footer' : footer,
    },
    mounted (){
      this.waypoints();
      this.initApp();
    },
    watch : {
      '$route' : function(){
        let that = this;
        setTimeout(function(){
          that.waypoints();
        },100);
      }
    },
    methods : {
      ...mapActions(['initApp']),
      waypoints : function() {

        $(".waypoints-instant").addClass('animated fadeInUp');

        var waypoints = document.getElementsByClassName('waypoints');

        for (var i = 0; i < waypoints.length; i++) {

          new Waypoint({
            element: waypoints[i],
            offset : '100%',
            handler: function() {
              var element = this.key.split('-')[1];
              var effect = this.element.attributes.getNamedItem('data');
              (effect != undefined) ? effect = effect.value : effect = "fadeIn";
              this.element.classList.add("animated", effect)  
            }
          });

        }

      }
    }
  }
</script>

<style  lang="scss">
@import '@/assets/css/colors.scss';
@import url(vue-multiselect/dist/vue-multiselect.min.css);
@import './assets/css/style.scss';
@import './assets/css/responsive.scss';
@import './assets/css/slick.css';
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,700');
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
@import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
</style>



// WEBPACK FOOTER //
// src/App.vue